import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/people-and-culture/client/PeopleAndCultureClient.tsx");
